<div class="container-fluid" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">

      @if (!isLoadingGroup && !isInGroup) {
        <div class="card mb-3 group-card">
          <div class="card-body d-flex align-items-center justify-content-between py-3 px-4 gap-3">
            <div class="d-flex align-items-center gap-3">
              <div class="group-card-icon">
                <fa-icon [icon]="['fas', 'users']" size="lg"></fa-icon>
              </div>
              <div>
                <div class="case-title mb-1">{{ 'group.landing-cta-title' | translate }}</div>
                <div class="search-text-label">{{ 'group.landing-cta-subtitle' | translate }}</div>
              </div>
            </div>
            <a routerLink="/borgenar/group" class="btn btn-sm btn-blue text-bold">
              {{ 'group.landing-cta-button' | translate }}
              <fa-icon [icon]="['fas', 'arrow-right']" size="lg" class="ms-1"></fa-icon>
            </a>
          </div>
        </div>
      }

      @if (isInGroup) {
        <div class="card mb-3">
          @if (isLoadingGroup) {
            <div class="card-body py-3 px-4">
              <div class="d-flex align-items-center gap-3">
                <div class="skeleton" style="width:36px;height:36px;border-radius:10px;flex-shrink:0"></div>
                <div class="flex-grow-1">
                  <div class="skeleton skeleton-eyebrow mb-2" style="width:160px"></div>
                  <div class="skeleton" style="height:12px;width:260px;border-radius:8px"></div>
                </div>
              </div>
            </div>
          }
          @if (!isLoadingGroup) {
            <div class="card-header d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <fa-icon [icon]="['fas', 'users']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>
                {{ 'label.min-borgenarsgrupp' | translate }}
              </div>
              <a routerLink="/borgenar/group" class="btn btn-sm btn-blue text-bold">
                {{ 'group.manage-button' | translate }}
                <fa-icon [icon]="['fas', 'arrow-right']" size="lg" class="ms-1"></fa-icon>
              </a>
            </div>
          }
          @if (!isLoadingGroup) {
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <span class="case-meta-label">{{ 'group.members-section-title' | translate }}</span>
                <span class="badge text-bg-secondary ms-2">{{ group?.members?.length ?? 0 }}</span>
              </div>
              @for (member of sortedMembers; track member) {
                <div class="group-member-row py-1">
                  <fa-icon [icon]="['fas', 'user']" size="sm" class="group-member-icon"></fa-icon>
                  <span class="group-member-name">{{ member.fullName }}</span>
                  @if (member.isCurrentUser) {
                    <span class="group-member-you">{{ 'group.you' | translate }}</span>
                  }
                  @if (!member.invitedByName) {
                    <span class="group-member-creator">{{ 'group.creator-label' | translate }}</span>
                  }
                  @if (member.email) {
                    <span class="group-member-email">{{ member.email }}</span>
                  }
                </div>
              }
            </div>
          }
        </div>
      }


      <div class="card mb-3">
        <div class="card-header">
          <fa-icon [icon]="['fas', 'magnifying-glass']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>
          {{ 'label.sok-konkurs' | translate }}
        </div>
        <div class="card-body">
          <p class="search-text-label mb-4">
            {{ 'texts.search-bankruptcy-hint' | translate }}
          </p>

          <form [formGroup]="form" (ngSubmit)="search()">
            <div class="row g-2 align-items-start">
              <div class="col-12 col-lg-10 mb-0">
                <label class="label-search" for="searchQuery">{{ 'label.search-bankruptcy-query' | translate }}</label>
                <input id="searchQuery" type="text" class="form-control" formControlName="searchQuery"
                  autocomplete="off" [placeholder]="'placeholder.search-bankruptcy' | translate" />

                  <div class="validation-space">
                    <small class="text-danger ms-2"
                      [class.invisible]="!(searchQueryField?.touched && searchQueryField?.invalid)">
                      {{ 'validation.search-query-required' | translate }}
                    </small>
                  </div>
                </div>

                <div class="col-12 col-lg-2 mb-0">
                  <label class="invisible">{{ 'button.search' | translate }}</label>

                  <button class="btn-garanti btn-blue w-100" type="submit" [disabled]="isSearching || form.invalid">
                    @if (!isSearching) {
                      <span>{{ 'button.search' | translate }}</span>
                    }
                    @if (isSearching) {
                      <span>{{ 'button.searching' | translate }}</span>
                    }
                  </button>

                  <div class="validation-space"></div>
                </div>
              </div>

              @if (showResults && searchResults.length === 0) {
                <div class="mt-2 text-muted">
                  {{ 'texts.no-hits-borgenar' | translate }}
                </div>
              }

              @if (searched && isSearching) {
                <div class="mt-4">
                  @for (i of skeletonRows; track i) {
                    <div class="search-skeleton-row">
                      <div class="skeleton skeleton-name"></div>
                      <div class="skeleton skeleton-orgnr"></div>
                      <div class="skeleton skeleton-date"></div>
                    </div>
                  }
                </div>
              }

              @if (showResults && searchResults.length > 0) {
                <div class="mt-3">
                  <table class="table table-hover search-results-table mb-0">
                    <thead>
                      <tr>
                        <th>{{ 'label.galdenar' | translate }}</th>
                        <th class="text-nowrap col-trustee">{{ 'label.konkursforvaltare' | translate }}</th>
                        <th class="text-nowrap col-orgnr">{{ 'label.orgnr' | translate }}</th>
                        <th class="text-nowrap col-date">{{ 'label.konkursdag' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (result of searchResults; track trackByCaseId($index, result)) {
                        <tr
                          [routerLink]="['/borgenar/arende', result.caseId]"
                          [queryParams]="{ from: 'search', name: result.caseName }"
                          [attr.aria-label]="result.caseName"
                          tabindex="0"
                          role="link"
                          (keydown.enter)="navigateToResult(result)">
                          <td class="result-name">{{ result.caseName }}</td>
                          <td class="text-nowrap">{{ result.trusteeName }}</td>
                          <td class="text-nowrap">{{ result.caseOrgNr }}</td>
                          <td class="text-nowrap">{{ result.caseDecisionDate | date:'yyyy-MM-dd' }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </form>
          </div>
        </div>


        @if (isLoadingMyCases || myCreditorCases?.length > 0) {
          <div class="card mb-3">
            <div class="card-header">
              <fa-icon [icon]="['fas', 'gavel']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>
              {{ 'label.mina-bevakningsarenden' | translate }}
            </div>
            <div class="card-body pt-0">
              @if (isLoadingMyCases) {
                <div>
                  @for (i of [1, 2]; track i) {
                    <div class="mt-3">
                      <div class="case-card card border-0 shadow-sm w-100">
                        <div class="card-body p-4">
                          <div class="flex-grow-1 gap-3">
                            <div class="case-main-row">
                              <div class="case-meta-item">
                                <div class="skeleton skeleton-eyebrow mb-2"></div>
                                <div class="skeleton skeleton-title mb-3"></div>
                              </div>
                              <div class="skeleton skeleton-number-box"></div>
                            </div>
                            <div class="case-meta">
                              <div class="case-meta-item">
                                <div class="skeleton skeleton-meta-label mb-1"></div>
                                <div class="skeleton skeleton-meta-value"></div>
                              </div>
                              <div class="case-meta-item">
                                <div class="skeleton skeleton-meta-label mb-1"></div>
                                <div class="skeleton skeleton-meta-value"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (!isLoadingMyCases && myCreditorCases?.length > 0) {
                <div>
                  @for (c of myCreditorCases; track c) {
                    <div class="mt-3">
                      <a class="case-card-link" [routerLink]="['/borgenar/arende', c.caseSummary.caseId]" [queryParams]="{ from: 'mine', name: c.caseSummary.caseName }" aria-label="Open case">
                        <div class="case-card card border-0 shadow-sm w-100" [title]="c.requiresAttention ? ('label.waiting-for-remark-attention' | translate) : ''">
                          <div class="card-body p-4">
                            <div class="d-flex justify-content-between align-items-start flex-wrap gap-3">
                              <div class="flex-grow-1 gap-3">
                                <div class="case-main-row">
                                  <div class="case-meta-item">
                                    <div class="case-eyebrow">
                                      {{ 'label.konkurs' | translate }}
                                    </div>
                                    <div class="case-title text-truncate">
                                      {{ c.caseSummary.caseName }}
                                      @if (c.requiresAttention) {
                                        <fa-icon [icon]="['fas', 'envelope']" class="attention-icon"></fa-icon>
                                      }
                                    </div>
                                  </div>
                                  <div class="case-number-box">
                                    <div class="case-number-label">{{ 'label.konkursdag' | translate }}</div>
                                    <div class="case-number-value">{{ c.caseSummary.caseDecisionDate | date:'yyyy-MM-dd' }}</div>
                                  </div>
                                </div>
                                <div style="display: flex; justify-content: space-between; align-items: stretch; margin-bottom: 10px;">
                                  <div class="case-meta">
                                    <div class="case-meta-item">
                                      <div class="case-meta-label">
                                        {{ 'label.orgnr' | translate }}
                                      </div>
                                      <div class="case-meta-value">
                                        {{ c.caseSummary.caseOrgNr }}
                                      </div>
                                    </div>
                                    <div class="case-meta-divider"></div>
                                    <div class="case-meta-item">
                                      <div class="case-meta-label">
                                        {{ 'label.konkursforvaltare' | translate }}
                                      </div>
                                      <div class="case-meta-value">
                                        {{ c.caseSummary.trusteeName }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>